import { LocationIdentifiedDataType } from 'src/app/services/interest/Location/location-service.type';

export const convertLocationIdentifiedToEditFormData = (location: LocationIdentifiedDataType) => {
  return {
    name: location.name,
    description: location.description,
    lat: location.lat,
    lng: location.lng,
    locationRecognizedId: location.locationRecognizedId,
    address: location.address,
  };
};
